module.exports = __webpack_public_path__ + "img/contact_cake-2.3ea3328b.webp";